// Import New Relic for error reporting
import newrelic from 'newrelic';

// Import the custom reportError function from the errorHelper module
import { reportError } from "@/helpers/errorHelper";

// Define the ErrorReporter class
export class ErrorReporter {
  /**
   * Capture and report an error.
   * @param {Error} error - The error object to be reported.
   * @param {Object} metadata - Additional metadata to be included with the error report.
   */
  static captureError(error, metadata = {}) {
    // Log the error to the console (commented out)
    // console.error(error);

    // Local development logging
    // Uncomment the following block to log error details in development mode
    // if (process.env.NODE_ENV === 'development') {
      // console.error('Error Details:', {
      //   message: error.message,
      //   stack: error.stack,
      //   ...metadata
      // });

      // Use the custom reportError function to log the error
      if (error) {
        reportError({
          message: error.message || error,
          stack: error.stack || error,
          ...metadata
        });
      } else {
        reportError({
          message: 'Unknown error',
          ...metadata
        });
      }
      return;
    // }

    // Production error reporting
    // Uncomment the following block to report errors to New Relic in production mode
    // if (process.env.NODE_ENV === 'production') {
    //   newrelic.noticeError(error, {
    //     context: metadata.context,
    //     additionalData: metadata.additionalData,
    //   });
    // }
  }
}